export const DEFAULT_COUNT = 5;
export const COMMENT_SIZE = 255;
export const EMAIL_MAX = 50;
export const PHONE_MAX = 10;
